export default {
  noTransactions: 'There are no open orders at the moment',
};
